import React, { useEffect, useState, useRef } from 'react'
import '../css/Portfolio.css'
import '../css/Home.css'
import GitHubIcon from '@material-ui/icons/GitHub';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Bounce } from 'gsap/gsap-core';
import { gsap } from "gsap";
import WebIcon from '@material-ui/icons/Web';
// import Swiper from 'react-id-swiper';
// import 'swiper/css/swiper.css';

function Portfolio() {

    const [deveImg, setdeveImg] = useState('dove1.png')
    const [doveImageNo, setdoveImageNo] = useState(1)
    const [spotifyimg, setspotifyimg] = useState('spotify1.png')
    const [spotifyImageNo, setSpotifyImageNo] = useState(1)
    const [smartImg, setsmartImg] = useState('smart1.png')
    const [smartImgNo, setsmartImgNo] = useState(1)
    const [hodoImg, sethodoImg] = useState('hodo1.png')
    const [hodoImgNo, sethodoImgNo] = useState(1)
    const [ticImg, setticImg] = useState('tic1.png')
    const [ticImgNo, setticImgNo] = useState(1)
    const [doveModal, setdoveModal] = useState(false);
    const [hodoModal, sethodoModal] = useState(false);
    const [smartModal, setsmartModal] = useState(false);
    const [ticModal, setticModal] = useState(false);
    const [spotifyModal, setspotifyModal] = useState(false);
    const [waModal, setwaModal] = useState(false);
    const [waImg, setwaImg] = useState('wa1.png');

    const params = {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
        },
        pagination: {
            el: '.swiper-pagination'
        }
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    useEffect((e) => {
        // gsap.from('#dovetail', { y: -200, duration: 2, ease: Bounce.easeOut, opacity: 0 })
    }, [])

    useInterval(() => {
        if (doveImageNo === 7) {
            setdeveImg('dove1.png')
            setdoveImageNo(1)
        } else {
            setdeveImg(`dove${doveImageNo + 1}.png`)
            setdoveImageNo(doveImageNo + 1)
        }
    }, 3000);

    useInterval(() => {
        if (spotifyImageNo === 3) {
            setspotifyimg('spotify1.png')
            setSpotifyImageNo(1)
        } else {
            setspotifyimg(`spotify${spotifyImageNo + 1}.png`)
            setSpotifyImageNo(spotifyImageNo + 1)
        }
    }, 3000);

    useInterval(() => {
        if (smartImgNo === 16) {
            setsmartImg('smart1.png')
            setsmartImgNo(1)
        } else {
            setsmartImg(`smart${smartImgNo + 1}.png`)
            setsmartImgNo(smartImgNo + 1)
        }
    }, 3000);

    useInterval(() => {
        if (hodoImgNo === 9) {
            sethodoImg('hodo1.png')
            sethodoImgNo(1)
        } else {
            sethodoImg(`hodo${hodoImgNo + 1}.png`)
            sethodoImgNo(hodoImgNo + 1)
        }
    }, 3000);

    useInterval(() => {
        if (ticImgNo === 10) {
            setticImg('tic1.png')
            setticImgNo(1)
        } else {
            setticImg(`tic${ticImgNo + 1}.png`)
            setticImgNo(ticImgNo + 1)
        }
    }, 3000);

    useInterval(() => {
        if (waImg === 'wa1.png')
            setwaImg('wa2.png')
        else
            setwaImg('wa1.png')
    }, 3000);

    const dovetailClick = () => {
        setdoveModal(true)
    }
    const hodoClick = () => {
        sethodoModal(true)
    }
    const smartClick = () => {
        setsmartModal(true)
    }
    const ticClick = () => {
        setticModal(true)
    }
    const spotifyClick = () => {
        setspotifyModal(true)
    }
    const waClick = () => {
        setwaModal(true)
    }

    const dovetailClickClose = () => {
        setdoveModal(false)
    }
    const hodoClickClose = () => {
        sethodoModal(false)
    }
    const smartClickClose = () => {
        setsmartModal(false)
    }
    const ticClickClose = () => {
        setticModal(false)
    }
    const spotifyClickClose = () => {
        setspotifyModal(false)
    }
    const waClickClose = () => {
        setwaModal(false)
    }

    function useInterval(callback, delay) {
        const savedCallback = useRef();

        // Remember the latest callback.
        useEffect(() => {
            savedCallback.current = callback;
        }, [callback]);

        // Set up the interval.
        useEffect(() => {
            let id = setInterval(() => {
                savedCallback.current();
            }, delay);
            return () => clearInterval(id);
        }, [delay]);
    }

    return (
        <div className="port__total">
            <Modal
                isOpen={doveModal}
                onRequestClose={dovetailClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => setdoveModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(7), (e, i) => (
                            <div>
                                <img src={`dove${i + 1}.png`} />
                                <p className="legend">Dovetail</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <Modal
                isOpen={hodoModal}
                onRequestClose={hodoClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => sethodoModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(9), (e, i) => (
                            <div>
                                <img src={`hodo${i + 1}.png`} />
                                <p className="legend">HodoPhile</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <Modal
                isOpen={smartModal}
                onRequestClose={smartClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => setsmartModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(16), (e, i) => (
                            <div>
                                <img src={`smart${i + 1}.png`} />
                                <p className="legend">LandSpect</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <Modal
                isOpen={ticModal}
                onRequestClose={ticClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => setticModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(10), (e, i) => (
                            <div>
                                <img src={`tic${i + 1}.png`} />
                                <p className="legend">Tech Innovation Club</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <Modal
                isOpen={spotifyModal}
                onRequestClose={spotifyClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => setspotifyModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(3), (e, i) => (
                            <div>
                                <img src={`spotify${i + 1}.png`} />
                                <p className="legend">Spotify Clone</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <Modal
                isOpen={waModal}
                onRequestClose={waClickClose}
                style={customStyles}
                contentLabel="Example Modal"
                className='modal__carousel'
            >
                <div className="modal__close" onClick={() => setwaModal(false)}>
                    <CloseIcon />
                </div>
                <div className="dove__modal">
                    <Carousel>
                        {Array.from(Array(2), (e, i) => (
                            <div>
                                <img src={`wa${i + 1}.png`} />
                                <p className="legend">Whatsapp Clone</p>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
            <div className="dovetail__total">
                <h3>DOVETAIL </h3>
                <div className="dovetail">
                    <div className='port__content'>
                        <img src={deveImg} id='dovetail'
                            onClick={dovetailClick}
                        />
                    </div>
                    <div className='card__details'>
                        <p className="sci">
                            This is a Real Time Chat application. It has direct messages as well as group messages features. It also has profile section for users. It has JWT based authentication which makes our app secure.
                        </p>
                        <div className="project__labels">
                            <div>React JS</div>
                            <div>Express JS</div>
                            <div>Socket.io</div>
                            <div>JWT</div>
                            <div>Firebase</div>
                            <div>Mongo DB</div>
                        </div>
                        <a href="https://dovetail-elan.herokuapp.com/" target="_blank" className="project__demo project__demo__web">
                            <WebIcon color="primary" fontSize="large" />
                            <p>Visit the Site</p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="dovetail__total">
                <h3>Hodophile </h3>
                <div className="dovetail">
                    <div className='card__details'>
                        <p className="sci">
                            HodoPhile is a front-end web application(desktop). It is based on interplanetary flights booking. It was built in a 72 hrs web dev competition conducted by IEEE Manipal which secured us the first runner-up position.                        </p>
                        <div className="project__labels">
                            <div>HTML</div>
                            <div>CSS</div>
                            <div>JavaScript</div>
                        </div>
                        <a href="https://hodo-phile.web.app/" target="_blank" className="project__demo project__demo__web">
                            <WebIcon color="primary" fontSize="large" />
                            <p>Visit the Site</p>
                        </a>
                    </div>
                    <div className='port__content'>
                        <img src={hodoImg} id='dovetail'
                            onClick={hodoClick}
                        />
                    </div>
                </div>
            </div>
            <div className="dovetail__total">
                <h3>LandSpect</h3>
                <div className="dovetail">
                    <div className='port__content'>
                        <img src={smartImg} id='dovetail'
                            onClick={smartClick}
                        />
                    </div>
                    <div className='card__details'>
                        <p className="sci">
                            This is my first FullStack(MERN) Project. And This is our Entry to SmartSite Contest conducted by Daksh. And we ended up as Second Runner Up in the Fest.
                        </p>
                        <div className="project__labels">
                            <div>React JS</div>
                            <div>Express JS</div>
                            <div>Firebase</div>
                        </div>
                        <div className="project__labels">
                            <div>Stripe</div>
                            <div>Mongo DB</div>
                        </div>
                        <a href="https://github.com/Shyam19sundar/SmartSite" target="_blank" className="project__demo project__demo__git">
                            <GitHubIcon color="primary" fontSize="large" />
                            <p>Github</p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="dovetail__total">
                <h3>Tech Innovation Club </h3>
                <div className="dovetail">
                    <div className='card__details'>
                        <p className="sci">
                            This is a Real Time Chat application. It has direct messages as well as group messages features. It also has profile section for users. It has JWT based authentication which makes our app secure.
                        </p>
                        <div className="project__labels">
                            <div>React JS</div>
                            <div>Express JS</div>
                            <div>GSAP</div>
                        </div>
                        <div className="project__labels">
                            <div>JWT</div>
                            <div>Firebase</div>
                            <div>Mongo DB</div>
                        </div>
                        <div className="project__labels">
                            <div>Three JS</div>
                        </div>
                        <div className="project__demo project__demo__web">
                            <WebIcon color="primary" fontSize="large" />
                            <p>Visit the Site</p>
                        </div>
                    </div>
                    <div className='port__content'>
                        <img src={ticImg} id='dovetail'
                            onClick={ticClick}
                        />
                    </div>
                </div>
            </div>
            <div className="dovetail__total">
                <h3>Spotify Clone </h3>
                <div className="dovetail">
                    <div className='port__content'>
                        <img src={spotifyimg} id='dovetail'
                            onClick={spotifyClick}
                        />
                    </div>
                    <div className='card__details'>
                        <p className="sci">
                            Built a Spotify clone with React JS, and Spotify-web-api . Also made use of Material-UI and Context API with React Hooks                        </p>
                        <div className="project__labels">
                            <div>React JS</div>
                            <div>Spotify-web-api</div>
                            <div>Context API</div>
                        </div>
                        <a href="https://github.com/Shyam19sundar/spotify-clone" target="_blank" className="project__demo project__demo__git">
                            <GitHubIcon color="primary" fontSize="large" />
                            <p>Github</p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="dovetail__total">
                <h3>Whatsapp Clone </h3>
                <div className="dovetail">
                    <div className='card__details'>
                        <p className="sci">
                            Built a WhatsApp clone using React JS with use of Context API for state Management and React Hooks . And for Backend Node JS with Express JS with MongoDB as the storage Database and Pusher for instant messaging.                        </p>
                        <div className="project__labels">
                            <div>React JS</div>
                            <div>Express JS</div>
                            <div>Pusher</div>
                        </div>
                        <div className="project__labels">
                            <div>Mongo DB</div>
                            <div>Context API</div>
                        </div>
                        <a href="https://github.com/Shyam19sundar/whatsapp-mern" target="_blank" className="project__demo project__demo__git">
                            <GitHubIcon color="primary" fontSize="large" />
                            <p>Github</p>
                        </a>
                    </div>
                    <div className='port__content'>
                        <img src={waImg} id='dovetail'
                            onClick={waClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Portfolio
